import { Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardData } from '../../hooks/useDashboardData';
import PageLayout from '../common/PageLayout';
import AssetAllocation from './AssetAllocation';
import AssetTable from './AssetTable';
import BalanceHistoryChart from './BalanceHistoryChart';
import DashboardOverview from './DashboardOverview';

const Dashboard: React.FC = () => {
    const { t } = useTranslation();
    const { currentBalance, assetsData, isBalanceDataLoading } = useDashboardData();

    return (
        <PageLayout title={t('dashboard.title')} maxWidth="xl">
            <Grid container spacing={2}>
                <Grid item xs={12} lg={9}>
                    <BalanceHistoryChart balance={currentBalance || 0} />
                </Grid>
                <Grid item xs={12} lg={3}>
                    <DashboardOverview balance={currentBalance || 0} />
                </Grid>
                <Grid item xs={12} lg={9}>
                    <AssetTable 
                        assets={assetsData as any} 
                        isLoading={isBalanceDataLoading} 
                    />
                </Grid>
                <Grid item xs={12} lg={3}>
                    <AssetAllocation
                        data={assetsData.map((asset) => ({
                            symbol: asset.displaySymbol,
                            percentage: asset.percentageOfTotalValue || 0,
                            color: undefined,
                        }))}
                        isLoading={isBalanceDataLoading}
                    />
                </Grid>
            </Grid>
        </PageLayout>
    );
};

export default Dashboard;
